// Dashboard
export const DASHBOARD = '/';
//  Sign-up
export const SIGN_UP = '/sign-up';
export const IQC_COMPETITION_ID = 'IQC2026S1';
export const PAC2026_COMPETITION_ID = 'PAC2026';
export const CHALLENGE_COMPETITION_ID = 'challenge';
export const IQC2026_DIALOG_DEADLINE = new Date('2026-05-19T00:00:00Z');
export const SIGN_UP_IQC = `${SIGN_UP}/${IQC_COMPETITION_ID}`;
//  Sign-in
export const SIGN_IN = '/sign-in';
//
//  SIMULATE
export const SIMULATE = '/simulate';
export const SIMULATE_LEARN = '/simulate/learn';
export const SIMULATE_DATA_EXPLORER = '/simulate/data';
export const SIMULATE_TUTORIAL = '/simulate/tutorial';
export const SIMULATE_COURSES = '/simulate/learn/courses';
//
// Competitions
export const COMPETITION_DETAILS_PATH = '/competition/:id/:filterName?';
// Competition whose name starts with this prefix means the user has entered the country-level
// Challenge (Gold tier) leaderboard, e.g. "Challenge - Mainland China".
export const CHALLENGE_LEADERBOARD_NAME_PREFIX = 'Challenge -';
// CTA target for the Gold tier popup — the Challenge leaderboard.
export const CHALLENGE_LEADERBOARD_PATH = '/competition/challenge';
//
//  Alphas
export const ALPHAS_UNSUBMITTED_PAGE_PATH = '/alphas/unsubmitted';
export const ALPHAS_LISTS_PAGE_PATH = '/alphas/lists';
export const ALPHAS_SUPER_SELECTION = '/alphas/super-selection';
export const ACE_2023_SUBMISSION_PATH = '/ACE2023-submissions';
//
// Alpha
export const ALPHA_DETAIL_PATH = '/alpha/:id';
//
//  Profile
export const PROFILE_ACCOUNT_PAGE_PATH_MOBILE = '/profile/account';
export const PROFILE_ACCOUNT_PAGE_PATH = '/profile/account/basic-details';
export const PROFILE_ACCOUNT_WORKDAY_PAGE_PATH = '/profile/account/workday';
export const PROFILE_PERFORMANCE_PAGE_PATH = '/profile/performance';
export const PROFILE_ACHIEVEMENTS_PAGE_PATH = '/profile/achievements';
export const PROFILE_AGREEMENTS_PAGE_PATH = '/profile/agreements';
export const PROFILE_REFERRALS_PAGE_PATH = '/profile/referrals';
export const PROFILE_PUBLIC_PAGE_PATH = '/profile/public';
export const PROFILE_DEACTIVATE_PAGE_PATH = 'profile/account/deactivate';
//
//  Learn
export const LEARN_PAGE_PATH = '/learn';
export const LEARN_PART_PATH_OPERATORS = `operators`;
export const LEARN_OPERATORS_PAGE_PATH = `${LEARN_PAGE_PATH}/${LEARN_PART_PATH_OPERATORS}`;
export const LEARN_OLD_DATA_AND_OPERATORS_PAGE_PATH = `${LEARN_PAGE_PATH}/data-and-operators`;
export const LEARN_VIDEO_COURSES_PAGE_PATH = '/learn/courses';
export const LEARN_TUTORIALS_PAGE_PATH = '/learn/documentation';
export const LEARN_OSMOSIS_RULES_HREF = `${LEARN_TUTORIALS_PAGE_PATH}/consultant-information/osmosis-allocation-guide-consultants`;
export const LEARN_TUTORIAL_SIMULATION_RESULTS = `${LEARN_TUTORIALS_PAGE_PATH}/interpret-results/parameters-simulation-results`;
export const LEARN_TEST_PERIOD_PATH = `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/test-period`;
export const LEARN_SEMI_OS_OS_PAGE_PATH = `${LEARN_TUTORIALS_PAGE_PATH}/interpret-results/parameters-simulation-results#is-semi-os-os?`;
export const LEARN_ALPHA_SUBMISSION_PAGE_PATH = `${LEARN_TUTORIALS_PAGE_PATH}/get-started/alpha-submission`;
export const LEARN_ALPHA_EXAMPLES_PAGE_PATH = `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/19-alpha-examples`;
export const WORLDQUANTBRAIN_SITE_URL = 'https://worldquantbrain.com';
export const WORLDQUANTBRAIN_PLATFORM_URL = 'https://platform.worldquantbrain.com';
export const SUPPORT_URL = 'https://support.worldquantbrain.com';

export const BRAIN_LABS_URL = '/profile/account/brainlabs';
export const HELP_CENTER_URL = `${SUPPORT_URL}/hc`;
export const COMMUNITY_TOPICS_URL = `${SUPPORT_URL}/hc/en-us/community/topics`;
export const GLOSSARY_URL = `${SUPPORT_URL}/hc/en-us/articles/4902349883927`;
export const DATAFIELDS_SCORE_URL = `${SUPPORT_URL}/hc/en-us/articles/24381503500311`;
export const ROBUSTNESS_SCORE_URL = `${SUPPORT_URL}/hc/en-us/articles/33979747207191`;
export const WEEKLY_SCORE_URL = `${SUPPORT_URL}/hc/en-us/articles/26802839959191`;
export const LEARN_HCAC2025_SIMULATION_RESULTS = `${HELP_CENTER_URL}/en-us/articles/26743191705879-What-is-the-scoring-criteria-for-HCAC`;
export const EVENTS_URL = `/events/`;
export const FAQ_URL = `${SUPPORT_URL}/hc/en-us`;
export const FAQ_SEARCH_URL = `${FAQ_URL}/search?utf8=%E2%9C%93`;
export const GLOBAL_ALPHATHON_FAQ_URL = `${HELP_CENTER_URL}/en-us/categories/7855871567639-Global-Alphathon`;
export const IITK_ALPHATHON_FAQ_URL = `${HELP_CENTER_URL}/en-us/categories/11462887219351-IITK-Alphathon-2023`;
export const MAPC_2023_ALPHATHON_FAQ_URL = `${HELP_CENTER_URL}/en-us/categories/11924609341975-Merged-Alpha-Performance-Competition`;
export const CONSULTANT_LEADERBOARD_FAQ_URL = `${HELP_CENTER_URL}/en-us/search?utf8=%E2%9C%93&query=%22consultant+leaderboard%22&commit=Search`;
export const GENIUS_URL = '/genius';
export const GENIUS_LEADERBOARD_PATH = '/genius/leaderboard';

export const IQC_FAQ_URL = `${HELP_CENTER_URL}/en-us/categories/12713090684951-IQC-2023`;
export const SPC_FAQ_URL = `${HELP_CENTER_URL}/en-us/categories/41681062887191`;
export const PROMPT_SUBMISSION_GUIDELINES_URL = `${HELP_CENTER_URL}/en-us/categories/41681062887191`;
export const LEARN_STARTER_PACK_PATH = `${LEARN_TUTORIALS_PAGE_PATH}/discover-brain/read-first-starter-pack`;

// Competitions
export const COMPETITIONS = '/competition';
export const COMPETITION_IQC = `${COMPETITIONS}/${IQC_COMPETITION_ID}`;
export const COMPETITION_IQC_GUIDELINES = `${COMPETITION_IQC}/agreement`;
export const SPC_COMPETITION_PATH = '/competition/spc';
export const POWER_POOL_COMPETITION_PATH = '/competition/power-pool';
export const REFERRALS_COMPETITION_PATH = '/competition/referrals';
export const PROMPT_SUBMISSIONS_PATH = '/competition/spc/submissions';

// IQC landing
export const IQC_LANDING = '/iqc';
export const IQC_LANDING_ROUTE = '/iqc/:language?';

export const CONSULTANT_FAQ_LINK =
  'https://support.worldquantbrain.com/hc/en-us/categories/4412989948823-Process-to-become-a-BRAIN-consultant';

//Consultant program landing
export const CONSULTANT_PROGRAM_LANDING_PATH = '/consultant-program/:language?';

// Alphathon Landing
export const ALPHATHON_LANDING_PATH = '/alphathon/:id';

//
//  Notifications & Announcements
export const ANNOUNCEMENTS_PAGE_PATH = '/messages/announcements/all';
export const NOTIFICATIONS_PAGE_PATH = '/messages/notifications/all';

export enum AlphaTabType {
  ALPHA_DISTRIBUTION = 'alphaDistribution',
  ALPHA_LIST = 'alphaList',
  ALPHA_TAG = 'alphaTag',
  SUPER_ALPHA = 'superAlpha',
  SUPER_SELECTION = 'superSelection',
  UNSUBMITTED = 'unsubmitted',
  SUBMITTED = 'submitted',
}

export const ALPHAS_SUBMENU_TABS = new Set([AlphaTabType.ALPHA_LIST, AlphaTabType.ALPHA_DISTRIBUTION]);

type AlphaTabTypeKey = keyof typeof AlphaTabType; // 'Red' | 'Green' | 'Blue'
export type AlphaTabTypeValue = typeof AlphaTabType[AlphaTabTypeKey]; // 'RED' | 'GREEN' | 'BLUE'

export const MOBILE_BREAKPOINTS = {
  table: { width: 768, height: 900 },
  mobile: { width: 320, height: 900 },
  desktop: { width: 1200, height: 900 },
};

//
// Editor tabs widths
// (when changing this values, the values in EditorTab.scss must be adjusted)
export const TAB_MAX_WIDTH = 200;
export const TAB_MIN_WIDTH = 110;

//
// Simulation tabs status
export const NEW_STATUS = 'new';
export const SIMULATING_STATUS = 'simulating';
export const UNREAD_STATUS = 'unread';
export const COMPLETED_STATUS = 'completed';
export const EDITED_STATUS = 'edited';
export const WARNING_STATUS = 'warning';
export const ERROR_STATUS = 'error';

// All the user data field related with the employer state
export const USER_DATA_FIELDS_EMPLOYER = [
  'employer',
  'title',
  'business',
  'description',
  'nonPublicInformation',
  'participationPermitted',
  'finance',
];

// All the user data field related with the employer finance state
export const USER_DATA_FIELDS_EMPLOYER_FINANCE = [
  'investmentAdvisory',
  'brokerage',
  'fundamentalResearch',
  'proprietaryTrading',
  'serviceEngagement',
  'exposureStatus',
  'employerServices',
  'exposureDetails',
];

// Placeholder for support URL
export const SUPPORT_URL_PLACEHOLDER = 'SUPPORT_URL_PLACEHOLDER';

// Walkthrough
export const WALKTHROUGHS = ['dashboardWalkthrough', 'dashboardWalkthrough-consultant', 'simulationWalkthrough', 'alphasWalkthroug'];

// Empty function
export const EMPTY_FUNCTION = () => {};

export const REACT_SNAP_USER_AGENT = 'ReactSnap';
